import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import styles from './timeline.module.scss';

type YearData = {
  value: number;
  label: string;
};

interface TimelineProps {
  years: YearData[];
  onChange?: (val: YearData) => void;
  value?: number;
}

export const Timeline: React.SFC<TimelineProps> = props => {
  const marks = {} as any;
  let value = 0;
  props.years.forEach((year, i) => {
    const key = (100 / (props.years.length - 1)) * i;
    marks[key] = { label: year.label, value: year.value };
    if (props.value === year.value) {
      value = key;
    }
  });

  const onChange = (val: number) => {
    if (props.onChange) {
      props.onChange(marks[val]);
    }
  };

  return (
    <div className={styles.timeline}>
      <Slider min={0} marks={marks} step={null} onChange={onChange} defaultValue={value} />
    </div>
  );
};
